import Siat from "../";

const routes = [
	{ name: "Scelta Pratiche", path: "/siatpratichescelta", component: Siat.SiatPraticheSceltaListPage, meta: { title: "Scelta Pratiche" } },
	{ name: "Pratiche Assegnate", path: "/siatpraticheassegnate", component: Siat.SiatPraticheAssegnateListPage, meta: { title: "Pratiche Assegnate" } },
];
export default routes;
